import { Button } from 'react-bootstrap';
import TextField from '../../../../@shared/Fields/textField';
import RequestForm, { FormControlProps } from '../../../../@shared/Forms/RequestForm';
import LinkButtonGroup, { ILinkButtonGroup } from '../ForgotDialogues/linkButtonGroup';

interface ILoginFormPresentation extends FormControlProps, ILinkButtonGroup {}

const LoginFormPresentation = ({
  method,
  errors,
  validated,
  onSubmit,
  control,
  onClickForgotPasswordDialog,
  onClickForgotTwoFactorVerificationDialog,
  onClickForgotPasswordAndTwoFactorVerificationDialog,
  ...props
}: ILoginFormPresentation) => (
  <>
    <RequestForm
      {...props}
      errors={errors}
      method={method}
      noValidate
      validated={validated}
      onSubmit={onSubmit}
      centered
    >
      <TextField
        id="emailOrUsername"
        label="Email ou Usuário"
        control={control}
        errorMessage={errors?.emailOrUsername?.message}
        isInvalid={errors?.emailOrUsername !== undefined}
      />
      <TextField
        id="password"
        label="Senha"
        type="password"
        control={control}
        errorMessage={errors?.password?.message}
        isInvalid={errors?.password !== undefined}
      />
      <Button type="submit">Logar</Button>
      <LinkButtonGroup
        onClickForgotPasswordDialog={onClickForgotPasswordDialog}
        onClickForgotTwoFactorVerificationDialog={onClickForgotTwoFactorVerificationDialog}
        onClickForgotPasswordAndTwoFactorVerificationDialog={
          onClickForgotPasswordAndTwoFactorVerificationDialog
        }
      />
    </RequestForm>
  </>
);

export default LoginFormPresentation;
